<template>
  <div class="main-div">
    <div class="heading-name">
      <img
       v-if="logo == 'briefcase' "
        height="20"
        width="20"
        src="../../../../assets/userDetails/briefcase.svg"
      />
      <img
       v-else-if=" 'heart' "
        height="20"
        width="20"
        src="../../../../assets/userDetails/heart.svg"
      />
      <p class="heading-text">{{heading}}</p>
    </div>
    <v-divider />
    <div class="btn-container">
      <div v-for="item in data" :key="item.id">
        <button :class="btnColor ? 'green-btn' : 'grey-btn'">{{item}}</button>
      </div>
      
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "buttonCard",
  props:{
    btnColor:Boolean,
    logo:String,
    heading:String,
    data:null
  }
};
</script>
  <style lang="scss" scoped>
.main-div {
  height: 260px;
  width: 32%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  p {
    margin-bottom: 0px;
  }
}
.heading-name {
  height: 52px;
  margin-left: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.heading-text {
    color: #3a3f3a;
    font-size: 16px;
    font-weight: 500;
  }
.btn-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 24px;
}
.green-btn {
  height: 43px;
  //width: 87px;
  padding: 4px;
  background: rgba(51, 145, 55, 0.05);
  border-radius: 8px;
  color: rgba(51, 145, 55, 1);
}
.grey-btn {
  height: 43px;
 // width: 87px;
  background: rgba(121, 126, 121, 0.05);
  border-radius: 8px;
  color: rgba(121, 126, 121, 1);
}
</style>